module.exports = __webpack_public_path__ + "static/media/sumofus-white-logo.5b6076b9.svg";